import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-message-deleteorms',
  templateUrl: './confirmation-message-deleteorms.component.html',
  styleUrls: ['./confirmation-message-deleteorms.component.scss']
})
export class ConfirmationMessageDeleteormsComponent implements OnInit {

  constructor(public dialogRef:MatDialogRef<ConfirmationMessageDeleteormsComponent>,) { }

  ngOnInit() {
  }
  onCloseClick() {
    this.dialogRef.close(false);
}

onConfirmDeleteClick() {
  this.dialogRef.close(true);
}
}
